import * as React from 'react';
import { Component } from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';

const styles = {
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    input: {
        minWidth: '120px'
    },
    fullWidth: {
        width: '100%'
    }
}

interface IDropdownProps {
    dropdownDefault: string;
    dropdownLabel: string;
    dropdownList: any[];
    onSelect: (object: any) => void;
    fullWidth: boolean;
}

interface IDropdownState {
    selectedObject: any;
}

export class Dropdown extends Component<IDropdownProps, IDropdownState> {
    constructor(props) {
        super(props);

        this.state = { selectedObject: this.props.dropdownDefault };
    }

    public render() {
        const classes = styles;
        const list = this.createDropdown();
        const widthClass = this.props.fullWidth ? classes.fullWidth : classes.input;

        return (
            <div style={widthClass}>
                <InputLabel shrink htmlFor={this.props.dropdownLabel}>{this.props.dropdownLabel}</InputLabel>
                <Select
                    fullWidth={this.props.fullWidth}
                    value={this.state.selectedObject}
                    onChange={this.onSelect}
                    input={<Input id='{this.props.dropdownLabel}' name={this.props.dropdownLabel + "name"} />}>
                    {list}
                </Select>
            </div>
        );
    }

    private createDropdown = () => {
        const items = this.props.dropdownList.map((item, i) =>
            <MenuItem key={i} value={item}>{item}</MenuItem>
        );

        return items;
    }

    private onSelect = (event) => {
        this.props.onSelect(event.target.value);
        this.setState({ selectedObject: event.target.value });
    }
}

export default (Dropdown);